<template>
    <div id="contenedor-listado-mobiles-deducciones">
        <template
            v-for="(deduccion, index) in listadoDeducciones">
            <v-card
                :key="index"
                class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <div
                    class="d-inline-block text-truncate">
                    {{ deduccion.nombre }}
                  </div>
                  <div
                    class="d-inline-block">
                    <opciones
                      :deduccion="deduccion">
                    </opciones>
                  </div>
                </v-card-title>
                <v-card-text>
                    {{ deduccion.porcentaje }}%
                </v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoMobilesDeducciones',
  props: {
    listadoDeducciones: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
